import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { verifyEmail } = useAuth();
  const [status, setStatus] = useState("checking"); // checking | ok | error
  const [msg, setMsg] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = new URLSearchParams(location.search).get("token");
    if (!token) { setStatus("error"); setMsg("Lien invalide."); return; }
    verifyEmail(token)
      .then(() => { setStatus("ok"); setTimeout(() => navigate("/app", { replace: true }), 1200); })
      .catch((e) => { setStatus("error"); setMsg(e?.response?.data?.detail || "Lien invalide ou expiré."); });
  }, [location.search, verifyEmail, navigate]);

  return (
    <div className="min-h-screen bg-brand-softer flex flex-col items-center justify-center px-5" data-testid="verify-email-page">
      <div className="bg-white rounded-3xl border border-brand-soft p-10 max-w-md w-full text-center">
        {status === "checking" && <><Loader2 className="w-10 h-10 animate-spin text-brand-limeDark mx-auto" /><p className="mt-4 text-brand-green/70">Vérification de votre e-mail…</p></>}
        {status === "ok" && <><CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto" /><h1 className="font-display text-2xl font-semibold text-brand-greenDeep mt-4">E-mail vérifié !</h1><p className="text-brand-green/60 mt-1">Redirection vers le choix de votre profil…</p></>}
        {status === "error" && <><XCircle className="w-12 h-12 text-red-500 mx-auto" /><h1 className="font-display text-2xl font-semibold text-brand-greenDeep mt-4">Vérification impossible</h1><p className="text-brand-green/60 mt-1">{msg}</p><Link to="/connexion" className="inline-block mt-5 px-5 py-2.5 rounded-full bg-brand-greenDeep text-white text-sm font-semibold">Retour à la connexion</Link></>}
      </div>
    </div>
  );
}
